import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserContextService } from '../providers/services/user-context.service';
import { OtpService } from '../providers/services/otp.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private otpService: OtpService,
    private userContextService: UserContextService
  ) {}

  /**
   * @function canActivate
   * validateForm method used to check the authentication on routing guard
   */
  async canActivate(): Promise<boolean | UrlTree> {
    try {
      const isAuthenticated = await this.userContextService.isAuthenticated();
      const isLoggedIn = this.otpService.isLoggedIn();
      if (isAuthenticated === null && !isLoggedIn) {
        if (this.router.url !== '/login') {
          return this.router.createUrlTree(['/login']);
        }
        return false;
      }
      return true;
    } catch (error) {
      return this.router.createUrlTree(['/login']);
    }
  }
}
